<template>
  <div class="expressEmployeeDetail">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <div class="title" v-if="EMId">{{ $t.expressEmployee.editEmployeeRole }}</div>
      <div class="title" v-else>{{ $t.expressEmployee.addEmployeeRole }}</div>

      <van-field
        v-model="form.EmployeeRoleStr"
        :label="$t.expressEmployee.employeeRole"
        @click="pickerShow('showEmployeeRolePicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.FullName"
        :label="$t.expressEmployee.surname"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.GenderStr"
        :label="$t.expressEmployee.gender"
        @click="pickerShow('genderPicker')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <div class="custom-date">
        <div class="date-btn1">{{ $t.expressEmployee.birthDate }}</div>
        <div class="date-btn2" @click="showTimeDate">
          <span v-if="form.BirthDate" class="value">{{ form.BirthDate }}</span>
          <span v-else class="placeholder">{{ $t.meta.select }}</span>
        </div>
      </div>

      <van-field
        v-model="form.Nationality"
        :label="$t.expressEmployee.nationality"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.IdCardNumber"
        :label="$t.expressEmployee.idCardNumber"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.IdCardAddress"
        :label="$t.expressEmployee.idCardAddress"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.CurrentAddress"
        :label="$t.expressEmployee.currentAddress"
        :placeholder="$t.meta.input"
        type="textarea"
      />

      <van-field
        v-model="form.PhoneNumber"
        :label="$t.expressEmployee.phoneNumber"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.AlternatePhone"
        :label="$t.expressEmployee.alternatePhone"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.Email"
        :label="$t.expressEmployee.email"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.EmergencyContact"
        :label="$t.expressEmployee.emergencyContact"
        :placeholder="$t.meta.input"
      />

      <van-field
        v-model="form.EmergencyPhone"
        :label="$t.expressEmployee.emergencyPhone"
        :placeholder="$t.meta.input"
      />

      <van-field :label="$t.expressEmployee.avatarPhoto">
        <template #input>
          <van-uploader v-model="headPhoto" :max-count="1" :after-read="afterRead1" />
        </template>
      </van-field>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showEmployeeRolePicker" round position="bottom">
      <van-picker
        :title="$t.expressEmployee.employeeRole"
        show-toolbar
        :columns="employeeRoleOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="roleConfirm($event)"
        @cancel="showEmployeeRolePicker = false"
      />
    </van-popup>

    <van-popup v-model="genderPicker" round position="bottom">
      <van-picker
        :title="$t.expressEmployee.gender"
        show-toolbar
        :columns="genderOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="genderConfirm($event)"
        @cancel="genderPicker = false"
      />
    </van-popup>

    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.expressEmployee.birthDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event)"
        @cancel="showTimePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Popup, Picker, Uploader } from "vant";

Vue.use(Form)
  .use(Field)
  .use(Button)
  .use(Icon)
  .use(Image)
  .use(Popup)
  .use(Picker)
  .use(Uploader);

export default {
  name: "expressEmployeeDetail",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      EMId: "",
      form: {
        EMId: "",
        EmployeeRole: 1,
        EmployeeRoleStr: "",
        HeadPhoto: "",
        FullName: "",
        GenderStr: "",
        Gender: 1,
        BirthDate: "",
        Nationality: "",
        IdCardNumber: "",
        IdCardAddress: "",
        CurrentAddress: "",
        PhoneNumber: "",
        AlternatePhone: "",
        Email: "",
        EmergencyContact: "",
        EmergencyPhone: "",
      },
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      headPhoto: [],
      //员工角色
      employeeRoleOptions: [
        {
          text: this.$t.expressEmployee.role1,
          value: 1,
        },
        {
          text: this.$t.expressEmployee.role2,
          value: 2,
        },
        {
          text: this.$t.expressEmployee.role3,
          value: 3,
        },
      ],
      showEmployeeRolePicker: false,
      //性别
      genderOptions: [
        {
          text: this.$t.expressEmployee.male,
          value: 1,
        },
        {
          text: this.$t.expressEmployee.female,
          value: 2,
        },
      ],
      genderPicker: false,
      //日期
      selectDate: new Date(),
      currentDate: "",
      showTimePicker: false,
    };
  },
  created() {
    const { EMId } = this.$route.query;
    this.EMId = EMId;
    if (this.EMId) {
      this.getExpressEmployeeInfo();
    }
  },
  methods: {
    genderConfirm(e) {
      this.form.GenderStr = e.text;
      this.form.Gender = e.value;
      this.genderPicker = false;
    },
    roleConfirm(e) {
      this.form.EmployeeRoleStr = e.text;
      this.form.EmployeeRole = e.value;
      this.showEmployeeRolePicker = false;
    },
    pickerShow(pickerName) {
      if (pickerName == "showEmployeeRolePicker") {
        this.employeeRoleOptions = [
          {
            text: this.$t.expressEmployee.role1,
            value: 1,
          },
          {
            text: this.$t.expressEmployee.role2,
            value: 2,
          },
          {
            text: this.$t.expressEmployee.role3,
            value: 3,
          },
        ];
      }
      if (pickerName == "genderPicker") {
        this.genderOptions = [
          {
            text: this.$t.expressEmployee.male,
            value: 1,
          },
          {
            text: this.$t.expressEmployee.female,
            value: 2,
          },
        ];
      }
      this[pickerName] = true;
    },
    getExpressEmployeeInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          EMId: this.EMId,
        };
        this.$api.storage
          .getExpressEmployeeInfo(param)
          .then((res) => {
            this.applyData(res.data);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data) {
      this.form.EMId = data.EMId;
      this.form.EmployeeRole = data.EmployeeRole;
      var employeeRole = this.employeeRoleOptions.find(
        (c) => c.value == data.EmployeeRole
      );
      if (employeeRole) {
        this.form.EmployeeRoleStr = employeeRole.text;
      }
      this.form.HeadPhoto = data.HeadPhoto;
      this.form.FullName = data.FullName;
      this.form.Gender = data.Gender;
      var gender = this.genderOptions.find((c) => c.value == data.Gender);
      if (gender) {
        this.form.GenderStr = gender.text;
      }
      this.form.BirthDate = data.BirthDate;
      this.form.Nationality = data.Nationality;
      this.form.IdCardNumber = data.IdCardNumber;
      this.form.IdCardAddress = data.IdCardAddress;
      this.form.CurrentAddress = data.CurrentAddress;
      this.form.PhoneNumber = data.PhoneNumber;
      this.form.AlternatePhone = data.AlternatePhone;
      this.form.Email = data.Email;
      this.form.EmergencyContact = data.EmergencyContact;
      this.form.EmergencyPhone = data.EmergencyPhone;

      if (this.form.HeadPhoto) {
        this.headPhoto.push({
          url: this.imgUrlFilter(this.form.HeadPhoto),
        });
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(images) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [images],
        startPosition: 0,
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      var request = null;
      if (this.EMId) {
        request = this.$api.storage.editExpressEmployeeInfo(param);
      } else {
        request = this.$api.storage.addExpressEmployeeInfo(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.HeadPhoto = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
    showTimeDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showTimePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date) {
      var formatDate = (val) => {
        var value = new Date(val);
        var time = value.toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      this.form.BirthDate = formatDate(date);
      this.showTimePicker = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.expressEmployeeDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
  .custom-date {
    padding: 12px 16px;
    border-bottom: 1px solid #ebedf0;
    .date-btn1 {
      width: 120px;
      display: inline-block;
      margin-right: 12px;
      font-size: 14px;
      color: #646566;
    }
    .date-btn2 {
      width: 50%;
      display: inline-block;
      font-size: 14px;
      .value {
        color: #323233;
      }
      .placeholder {
        color: #c3c3c3;
      }
    }
  }
}
</style>
